<!--
 * @Author: your name
 * @Date: 2020-11-11 09:54:06
 * @LastEditTime: 2020-11-11 14:48:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/home/components/StoreDet/index.vue
-->
<template>
  <!-- 名称 -->
  <div class="list_name">
    <img :src="titleImg" alt="" />
    <span class="font16 colo0 font_weight400 line_height_22">{{ title }}</span>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    titleImg: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.list_name {
  margin: 12px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 24px;
    margin-right: 4px;
  }
  span {
    color: var(--primary-color);
  }
}
</style>
